import axios from 'axios';
import { Service } from 'axios-middleware';
import { tokenManager } from '../../../../services/tokenManager';
import { installBuildOnlyAxiosGuard } from '../../../../services/buildOnlyApiPolicy';

installBuildOnlyAxiosGuard(axios);

const service = new Service(axios);

service.register({
    async onRequest(config) {
        // Get session token from token manager (initialized by AppBridgeAuthInjector)
        if (tokenManager.isInitialized()) {
            try {
                const token = await tokenManager.getToken();
                // append your request headers with an authenticated token
                config.headers["Authorization"] = `Bearer ${token}`;
            } catch (err) {
                console.log("Unable to get shopify token", err);
            }
        }
        return config;
    },
    onSync(promise) {
        return promise;
    },
    onResponse(response) {
        return response;
    }
});

console.log('Ready to fetch.');
